import {Injectable} from '@angular/core';
import {Promoter, PromoterService as Api} from '../../generated/sales-terminal-client';
import {LanguageService} from '../language/language.service';
import {Observable, tap} from 'rxjs';
import {SnackService} from '../snack/snack.service';
import {PageableResult, ScrollLoadService} from '../../components/scroll-load-component/scroll-load.component';
import {ScrollLoad} from '../../components/scroll-load-component/ScrollLoad';

@Injectable()
export class PromoterService implements ScrollLoadService<Promoter> {
  constructor(private _api: Api,
              private languageService: LanguageService,
              private snackService: SnackService) {}

  public search(data: any): Observable<PageableResult<Promoter>> {
    return this._api.promoterSearch(
      data.q,
      this.languageService.selectedLang,
      data.page,
      data.pageSize
    ).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    ) as Observable<PageableResult<Promoter>>;
  }
  public displayScrollLoadOption(option: Promoter): string {
    return '<b>' + option.title + '</b>' + (option.regNumber ? (', ' + option.regNumber) : '') + (option.ocraCode ? (', ' + option.ocraCode) : '');
  }
  public displayScrollLoadSelection(selection: Promoter): string | undefined {
    if (!selection) { return ''; }
    const promoterDetails = [];
    promoterDetails.push(selection.title);
    if (selection.regNumber) {
      promoterDetails.push(selection.regNumber);
    }
    if (selection.ocraCode) {
      promoterDetails.push(selection.ocraCode);
    }
    let displayName = '';
    if (promoterDetails.length) {
      displayName = displayName.concat(promoterDetails.join(', '));
    }
    return displayName;
  }
  public getScrollLoad(pageSize?: number, idKey?: string): ScrollLoad<Promoter> {
    return new ScrollLoad<Promoter>(pageSize || 50, idKey || 'id', 'q');
  }

  public getAll(): Observable<Array<Promoter>> {
    return this._api.findPromoters().pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }
}
